import { ICaseLawDocumentService } from "../service/CaseLawDocumentService";

export default class ArchiveCaseLawDocumentInteractor {
  private caseLawDocumentService: ICaseLawDocumentService;

  constructor({ caseLawDocumentService }: any) {
    this.caseLawDocumentService = caseLawDocumentService;
  }

  async execute(caseLawDocumentId: number) {
    return await this.caseLawDocumentService.archiveCaseLawDocument(
      caseLawDocumentId
    );
  }
}
